import Vue from "vue";
import axios from "../node_modules/axios";
import VueAxios from "../node_modules/vue-axios";
Vue.use(VueAxios, axios);

export default new VueAxios();
